import { 
    axiosPost, axiosGet, // TO DO unused import // TO DO lazy load component
 axiosPostAuthorize, axiosGetAuthorize } from '../AxiosRequests';
import { AddInquiryEmails, UpdateInquiryEmails, DeleteInquiryEmails, GetInquiryEmailsList, GetInquiryEmailsById,SendInquiryEmails, GetProductInquiryEmailDetail,GetInquiryHistoriesList
,GetInquiryResponseListByInquiryEmailId,GetInquiryRequestConutById,GetInquiryResponseListForUnmapped,GetInquiredProductDetails,UpdateInquiryResponse,GetInquiryEmailsListForUnmapped 
,GetInquiryEmailsHistory,AddReasonForInquiry,DeleteUnmappedResponseEmail,GetAllUnmappedDeletedEmailsList} from '../ApiEndPoints';

export default class InquiryEmailService{

    async addInquiryEmails(request){
        return axiosPostAuthorize(AddInquiryEmails, request);
    }

    async updateInquiryEmails(request){
        return axiosPostAuthorize(UpdateInquiryEmails, request);
    }

    async deleteInquiryEmails(request){
        return axiosPostAuthorize(DeleteInquiryEmails, request);
    }

    async getInquiryEmailsList(request){
        return axiosPostAuthorize(GetInquiryEmailsList, request);
    }

    async getInquiryEmailsById(request){
        return axiosGetAuthorize(GetInquiryEmailsById, request);
    }
    async sendInquiryEmails(request){
        return axiosPostAuthorize(SendInquiryEmails, request);
    }
    async getProductInquiryEmailDetail(request){
        return axiosPostAuthorize(GetProductInquiryEmailDetail, request);
    }   
    async getInquiryHistoriesList(request){
        return axiosPostAuthorize(GetInquiryHistoriesList, request);
    }
    
    async getInquiryResponseListByInquiryEmailId(request){
        return axiosPostAuthorize(GetInquiryResponseListByInquiryEmailId, request);
    }

    async getInquiryRequestConutById(request){
        return axiosGetAuthorize(GetInquiryRequestConutById, request);
    }
    
    async getInquiryResponseListForUnmapped(request){
        return axiosPostAuthorize(GetInquiryResponseListForUnmapped, request);
    }    
    async getInquiryEmailsListForUnmapped(request){
        return axiosGetAuthorize(GetInquiryEmailsListForUnmapped, request);
    }    
    async updateInquiryResponse(request){
        return axiosPostAuthorize(UpdateInquiryResponse, request);
    }
    async getInquiredProductDetails(request){
        return axiosGetAuthorize(GetInquiredProductDetails, request);
    }
    async getInquiryEmailsHistory(request){
        return axiosPostAuthorize(GetInquiryEmailsHistory, request);
    }
    async addReasonForInquiry(request){
        return axiosPostAuthorize(AddReasonForInquiry, request);
    }
    async deleteUnmappedResponseEmail(request){
        return axiosPostAuthorize(DeleteUnmappedResponseEmail, request);
    }
    async getAllUnmappedDeletedEmailsList(request){
        return axiosPostAuthorize(GetAllUnmappedDeletedEmailsList, request);
    }   
    
}